import { render, staticRenderFns } from "./PackageBody.vue?vue&type=template&id=ff4108a8&scoped=true&"
import script from "./PackageBody.vue?vue&type=script&lang=js&"
export * from "./PackageBody.vue?vue&type=script&lang=js&"
import style0 from "./PackageBody.vue?vue&type=style&index=0&id=ff4108a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4108a8",
  null
  
)

export default component.exports